import { queryOptions } from "@tanstack/react-query";

import { getDashboardOverview } from "@/lib/api/dashboard";
import { listAuditLogs } from "@/lib/api/audit-logs";

export const dashboardKeys = {
  all: ["dashboard"] as const,
  overview: () => [...dashboardKeys.all, "overview"] as const,
  recentAuditLogs: () => [...dashboardKeys.all, "recent-audit-logs"] as const,
};

export const dashboardOverviewQueryOptions = queryOptions({
  queryKey: dashboardKeys.overview(),
  queryFn: () => getDashboardOverview(),
  refetchInterval: 15_000,
  staleTime: 5_000,
});

export const dashboardRecentAuditLogsQueryOptions = queryOptions({
  queryKey: dashboardKeys.recentAuditLogs(),
  queryFn: () => listAuditLogs({ limit: 25 }),
  refetchInterval: 15_000,
  staleTime: 5_000,
});
